import { render, staticRenderFns } from "./NewDailyReportPage.vue?vue&type=template&id=7844a5d4"
import script from "./NewDailyReportPage.vue?vue&type=script&lang=js"
export * from "./NewDailyReportPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports